{
    "warning": "ВНИМАНИЕ!",
    "message": "Не вводите и не вставляйте код, функции которого вы не понимаете.\nИспользование этой консоли может позволить злоумышленникам выдать себя за вас и украсть вашу информацию с помощью атаки типа Self-XSS."
}
